import { ReactNode, forwardRef } from "react";
import { Link } from "react-router-dom";
import { RenderWhen } from "../../../../components";
import { enums } from "../../../../shim/jsbridge";
import { FILTER_KEYWORDS } from "../../../search/consts";
import { StoryParagraphs } from "../../@types/sample_details";
import { getSearchPivotLink } from "../../util";

interface ISampleStoryProps {
  className?: string;
  prefix?: ReactNode;
  storyParagraphs?: StoryParagraphs;
}

function getStoryLink(storyArgument?: {
  link: string;
  text: string;
  type: number;
}) {
  if (!storyArgument) {
    return undefined;
  }

  return storyArgument?.type === enums.storyteller_link_type.ADVANCED_SEARCH ? (
    <Link
      to={getSearchPivotLink(storyArgument.link, {
        [FILTER_KEYWORDS.TIME_TYPE]: "firstseen",
        [FILTER_KEYWORDS.PERIOD_TYPE]: "all"
      })}
      data-testid={`sample_story_link_${storyArgument.text}`}
    >
      {storyArgument.text}
    </Link>
  ) : (
    <a
      href={storyArgument.link}
      data-testid={`sample_story_link_${storyArgument.text}`}
    >
      {storyArgument.text}
    </a>
  );
}

const SampleStory = forwardRef<HTMLDivElement, ISampleStoryProps>(
  ({ className, storyParagraphs, prefix }, ref) => (
    <div ref={ref} className={className} data-testid="sample_story">
      <RenderWhen condition={Boolean(prefix)}>{prefix}</RenderWhen>
      {storyParagraphs?.map(({ content, arguments: storyArguments }, index) => {
        const contentSplit = content.split("{}");

        return (
          <p key={`${content}_${index}`}>
            {contentSplit.map((contentPiece, i) => {
              const storyArgument = storyArguments[i];

              return (
                <span key={`${contentPiece}_${i}`}>
                  {contentPiece}
                  {getStoryLink(storyArgument)}
                </span>
              );
            })}
          </p>
        );
      })}
    </div>
  )
);

export default SampleStory;
